import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';

// We don't display border & box-shadow if the admin decides it. Can be useful if the header is transparent or white.
const useDisplayNavigationDropShadow = ({ network } = {}) => {
  const { currentNetwork } = useDefaultAppContexts();

  const networkData = network || currentNetwork;

  return networkData?.theming?.fo?.fo_header_separator_display;
};

export default useDisplayNavigationDropShadow;
